<template>
  <!-- MODAL -->
  <TransitionRoot as="template" :show="open">
    <Dialog class="relative z-50" @close="closeDialog">
      <TransitionChild
        as="template"
        enter="ease-out duration-300"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="ease-in duration-200"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-gray-800 bg-opacity-50 transition-opacity" />
      </TransitionChild>

      <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div class="flex min-h-full items-center justify-center p-4 text-center sm:items-center sm:p-0">
          <TransitionChild
            as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <DialogPanel
              class="relative transform overflow-hidden rounded-lg bg-white px-6 py-8 text-left shadow-xl transition-all sm:w-full sm:max-w-3xl"
            >
              <!-- Header -->
              <div class="flex justify-between items-center border-b pb-4 mb-4">
                <h2 class="text-2xl font-bold text-gray-800">{{ title }}</h2>
                <button
                  @click="closeDialog"
                  type="button"
                  class="text-gray-400 hover:text-gray-600"
                >
                  <span class="sr-only">Fechar</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    stroke-width="2"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>

              <!-- Content -->
              <div class="space-y-6">
                <!-- Renderizar os Dados -->
                <div
                  v-for="[key, value] in filteredData"
                  :key="key"
                  class="p-4 border rounded-lg bg-gray-50 shadow-sm"
                >
                  <!-- Caso seja um Array -->
                  <template v-if="Array.isArray(value)">
                    <h3 class="text-lg font-semibold text-gray-700 capitalize mb-2">
                      {{ key }}
                    </h3>
                    <ul class="list-disc pl-6 text-sm text-gray-600 space-y-1">
                      <li
                        v-for="(item, index) in value"
                        :key="index"
                        class="bg-gray-100 p-2 rounded-md"
                      >
                        <div
                          v-if="typeof item === 'object'"
                          class="space-y-1"
                        >
                          <div
                            v-for="(subValue, subKey) in item"
                            :key="subKey"
                            class="text-sm"
                          >
                            <strong class="text-gray-700">{{ subKey }}:</strong>
                            <span class="text-gray-600">{{ subValue }}</span>
                          </div>
                        </div>
                        <span v-else class="text-gray-600">{{ item }}</span>
                      </li>
                    </ul>
                  </template>

                  <!-- Caso seja um Objeto -->
                  <template v-else-if="typeof value === 'object' && value !== null">
                    <h3 class="text-lg font-semibold text-gray-700 capitalize mb-2">
                      {{ key }}
                    </h3>
                    <div class="pl-5 space-y-1 text-sm text-gray-600">
                      <div
                        v-for="(subValue, subKey) in value"
                        :key="subKey"
                      >
                        <strong class="text-gray-700">{{ subKey }}:</strong>
                        <span>{{ subValue }}</span>
                      </div>
                    </div>
                  </template>

                  <!-- Caso seja um Valor Simples -->
                  <template v-else>
                    <div class="text-sm">
                      <strong class="text-gray-700 capitalize">{{ key }}:</strong>
                      <span class="text-gray-600">{{ value }}</span>
                    </div>
                  </template>
                </div>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from "@headlessui/vue";

export default {
  name: "CommonView",
  props: {
    data: {
      type: Object,
      required: true,
    },
    open: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  computed: {
    filteredData() {
      // Retorna um objeto sem o campo 'id'
      return Object.entries(this.data).filter(([key]) => key !== "id");
    },
  },
  methods: {
    closeDialog() {
      this.$emit("update-open", false);
    },
  },
  components: {
    Dialog,
    DialogPanel,
    TransitionChild,
    TransitionRoot,
  },
};
</script>

<style scoped>
.text-blue-800 {
  color: #1e40af;
}
</style>
